import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHeadMaterialUi from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import { lighten } from "@material-ui/core/styles/colorManipulator";

class TableHead extends React.Component {
  render() {
    const { order, orderBy, rows } = this.props;

    return (
      <TableHeadMaterialUi>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                sortDirection={orderBy === row.id ? order : false}
              >
                {row.sortType ? (
                  <Tooltip
                    title={"Sort"}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.id}
                      direction={order}
                      onClick={() => {
                        if (row.id === orderBy) {
                          const newOrder = order === "asc" ? "desc" : "asc";

                          this.props.sortOn(row.id, newOrder, row.sortType);
                        } else {
                          this.props.sortOn(row.id, order, row.sortType);
                        }
                      }}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                ) : (
                  <div style={{ width: "50px" }}>{row.label}</div>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHeadMaterialUi>
    );
  }
}

TableHead.propTypes = {
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired
};

export { TableHead };



// WEBPACK FOOTER //
// ./src/components/common/TableHead.js